import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux'
import { AnimatePresence } from "framer-motion"

import { OverviewSection, BillingSection, InvoiceSection } from './Sections'
import { FaExclamation } from 'react-icons/fa'
import { Animation } from 'components'

import { userContext } from 'context'
import * as actionCreators from 'store/actions'
import * as api from 'api'

const Container = styled.div`
    display: grid;
    row-gap: 1rem;
    grid-template-columns: auto;
    grid-template-rows: auto auto auto;
`

const Section = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 1rem 0;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 1rem;
    /* border-bottom: ${props => props.styles && props.styles.borderBottom || '1px solid var(--secondary-color)'}; */
    padding: 0.5rem;
`

const Warning = styled.div`
    margin: 0.5rem 0 1rem 0;
    padding: 1rem;
    border-radius: 5px;
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    cursor: pointer;
    display: grid;
    align-items: center;
    justify-items: flex-start;
    grid-template-columns: min-content 1fr;
    grid-column-gap: 1rem;
    font-size: 0.9rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const SubscriptionTab = props => {
    const {

    } = props
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const planStatus = user['subscription_status']
    const [paymentUrl , setUrl] = React.useState(null)
    const [action, setAction] = React.useState(null)

    React.useEffect(() => {
        if(planStatus === 'past_due'){
            api.getPaymentIntent({userId: user['uid']})
            .then(res => {
                const paymentIntent = res.data['paymentIntent']
                let url
                if(paymentIntent && paymentIntent['status'] === 'requires_action'){
                    url = paymentIntent.next_action.use_stripe_sdk['stripe_js']
                    url && setUrl(url)
                    setAction('requires_action')
                } else if (paymentIntent && paymentIntent['status'] === 'requires_payment_method') {
                    api.collectPaymentMethod({userId: user['uid']})
                    .then(res => { 
                        url = res.data['url'] 
                        url && setUrl(url)
                        setAction('requires_payment_method')
                    })
                }
            })
            .catch(err => {})
        }
    }, [])

    return(
        <Container>
            <Section>
                <Title styles={{borderBottom: '2px solid transparent'}}>Overview</Title>
                <AnimatePresence>
                    {paymentUrl && 
                    <Animation animation='expand'>
                        <Warning onClick={() => {paymentUrl && window.open(paymentUrl,'_self')}}>
                            <FaExclamation style={{color: 'var(--secondary-accent-color)', fontSize: '1.2rem'}}/>
                            {action === 'requires_payment_method' ? 'Something went wrong with your payment. Please click here to add a new payment method.'
                            : action === 'requires_action' ? 'Your card payment requires authentication. Please click here to proceed.'
                            : ''}
                        </Warning> 
                    </Animation>}
                </AnimatePresence>
                <OverviewSection/>
            </Section>

            {user['subscription_plan'] === userContext.PLANS.PREMIUM && 
            <Section>
                <Title>Billing</Title>
                <BillingSection/>
            </Section>}

            <Section>
                <Title>Invoices</Title>
                <InvoiceSection/>
            </Section>
        </Container>
    )
}

export default SubscriptionTab;